<template>
  <require from="framework/html_behaviors/af-mutex-click"></require>
  <require from="controls/as-page-header"></require>
  <require from="controls/as-page-jumbo.html"></require>
  <require from="controls/as-form-widget.html"></require>
  <require from="controls/bs-form-lookup"></require>
  <require from="components/transfer-user-roles-form"></require>

  <div class="admin-transfer-user-roles-screen">
    <as-page-jumbo icon="fas fa-fast-forward fa-fw" heading="Transfer User Countries Roles" intro="Please select user whose countries roles you want to transfer to another user.">
      <div slot="default">
        <as-form-widget>
          <div slot="default">
            <div class="form-row flex-nowrap">
              <div class="col-md-12 col-lg-6">
                <bs-form-lookup label.bind="userGroupLabel" placeholder="Find by surname, login or email" item.bind="transferFrom & validate" options.bind="usersLookupOptions" value-path="name" template-path="templates/user-lookup.html" stick-mode="true" disabled.bind="controller.disabled" tooltip="Type to search for bp employee, then pick the one from the list"></bs-form-lookup>
              </div>
            </div>
          </div>
        </as-form-widget>
      </div>
    </as-page-jumbo>
    <form class="container-fluid">
      <as-page-header if.bind="transferFrom" heading.bind="transferFrom.name" back-visible.bind="false">
        <div class="sc-buttons-container text-nowrap" slot="aside">
          <button type="submit" class="btn btn-primary" af-mutex-click.call="transfer()" if.bind="transferButtonVisible">
            <i class="fas fa-fast-forward"></i>Transfer
          </button>
          <button type="button" class="btn btn-light" af-mutex-click.call="reset()" if.bind="resetButtonVisible">
            Reset
          </button>
        </div>
      </as-page-header>
      <transfer-user-roles-form if="condition.bind: transferFrom; cache: false" model.bind="model" changed.bind="changed"></transfer-user-roles-form>
    </form>
  </div>
</template>
